import * as Turbo from "@hotwired/turbo"
import { Controller } from "stimulus"

export default class extends Controller {
  static get targets() {
    return ["form", "order", "amount", "total", "email", "name", "to", "phone", "error", "loading", "label", "submit"]
  }

  secret = ""
  card = {}

  connect = () => {
    // Set up Stripe.js and Elements to use in checkout form
    const elements = stripe.elements();

    const card = elements.create("card", {
      style: {
        base: {
          color: "#32325d",
        }
      }
    })

    card.on("change", ({error}) => {
      let displayError = document.getElementById("card-errors");
      if (error) {
        displayError.textContent = error.message
      } else {
        displayError.textContent = ""
      }
    })

    card.mount("#card-element")
    this.card = card
  }

  /**
   * changeAmount handles the change event so that the amount can be updated.
   * @param {HTMLEvent} ev HTML change event.
   */
  changeAmount = (_) => {
    const amount = this.amountTarget.value || 0.0
    this.totalTarget.innerText = "$" + amount.toString()
  }

  /**
   * pay submits the payment to Stripe to complete the gift card order.
   */
  pay = (ev) => {
    ev.preventDefault()

    const form = this.formTarget

    // Disable the submit button while the form is being submittted.
    this.submitTarget.disabled = true
    this.submitTarget.classList.add("opacity-80")

    this.labelTarget.classList.add("hidden")
    // Clear the error, if one exists.
    this.errorTarget.classList.add("hidden")

    this.loadingTarget.classList.remove("hidden")

    // Check to see if the order is zero dollars. If it is, then just submit
    // the form without doing anything else.
    if (this.totalTarget.value === "0") {
      Turbo.navigator.submitForm(form)
      return
    }

    this._fetchPaymentIntent().then(() => {
      stripe.confirmCardPayment(this.secret, {
        payment_method: {
          card: this.card,
          billing_details: {
            address: {
              city: "Thunder Bay",
              country: "CA",
              state: "Ontario"
            },
            email: this.emailTarget.value,
            name: this.nameTarget.value
          }
        }
      }).then((result) => {
        // Re-enable the submit button and show things again.
        this.submitTarget.disabled = false
        this.submitTarget.classList.remove("opacity-80")
        this.labelTarget.classList.remove("hidden")
        this.loadingTarget.classList.add("hidden")

        if (result.error) {
          this.errorTarget.innerText = result.error.message
          this.errorTarget.classList.remove("hidden")
        } else {
          // The payment succeeded!
          this.labelTarget.innerText = "Completed"

          // Submit the form via Turbo.
          Turbo.navigator.submitForm(form)
        }
      })
    })
  }

  /**
   * handleErr is a generic error handler that will reset the form and display
   * errors in the error div.
   */
  _handleErr = (response) => {
    if (!response.ok) {
      if (response.error) {
        this.submitTarget.disabled = false
        this.submitTarget.classList.remove("opacity-80")
        this.labelTarget.classList.remove("hidden")
        this.loadingTarget.classList.add("hidden")

        this.errorTarget.innerText = response.message
        this.errorTarget.classList.remove("hidden")
        throw response.error
      }
    }

    return response
  }

  /**
   * _fetchPaymentIntent fetches a Stripe payment intent for the current order
   * from the server.
   */
  _fetchPaymentIntent = () => {
    return fetch("/order/giftcardintent", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        amount: parseInt(parseFloat(this.amountTarget.value) * 100),
        from: this.nameTarget.value,
        to: this.toTarget.value,
        email: this.emailTarget.value,
        phone: this.phoneTarget.value
      })
    }).then((result) => { return result.json() })
    .then(this._handleErr)
    .then((data) => {
      this.secret = data.client_secret
      this.orderTarget.value = data.order_id
    }).catch((err) => {
      console.log("error:", err)
    })
  }
}
